import { Component, OnInit } from '@angular/core';
import { ThesesResource, ThesesService } from '../../services/data/theses.service';
import { MessageToastService } from '../../services/common/message-toast.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { tap } from 'rxjs/operators';
import { PrimeNGConfig } from 'primeng/api';

@UntilDestroy()
@Component({
  selector: 'app-theses-end-reg-msg',
  templateUrl: './theses-end-reg-msg.component.html',
  styleUrls: ['./theses-end-reg-msg.component.css']
})
export class ThesesEndRegMsgComponent implements OnInit {

  _alias: string;
  confName: string;
  thesesResource: ThesesResource;

  idTheses: string;
  emailMsg: string;

  isFormReady: boolean = false;

  constructor(
    private thesesService: ThesesService,
    private msg: MessageToastService,
    private router: Router,
    private aRouter: ActivatedRoute,
    private primeNgConfig: PrimeNGConfig
    ) {
      aRouter.paramMap.pipe(
        untilDestroyed(this),
        tap(data =>  this._alias = data.get('alias'))
      ).subscribe();

      this.thesesResource = thesesService.getTheses();
      this.confName = thesesService.getConferenceName();
    }

  ngOnInit(): void {

    this.isFormReady = false;

    this.primeNgConfig.ripple = true;

    if (this.thesesResource?.mainAuthor === null){
      this.router.navigate(['/theses', this._alias]);
    }

    this.idTheses = this.thesesService.thesesResult.id;

    this.emailMsg = this.thesesService.thesesResult.emailMessage;

    this.isFormReady = true;
    // console.log(this._alias);
    // console.log(this.thesesResource);
    // console.log('ConfName: ' + this.thesesService.getConferenceName());
  }

  goHome() {
    this.router.navigate(['/']);
  }

  addNewTheses() {
    this.router.navigate([`/theses/${ this._alias }`]);
  }

  viewTheses() {
    this.router.navigate([`/abstract-review/${ this.idTheses }`]);
    // console.log('Soon.....');
  }

}
